import { useSwaggerlessContext } from 'Context/SwaggerlessContext';
import React, { useEffect, useState } from 'react';
import {
  Box, Link, Typography,
} from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import Button from 'Components/UI/Button';
import { supportedPreviewExtensions } from 'Consts/EnumeratedValues';
import PropTypes from 'prop-types';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';

function isPreviewable(filename) {
  const extArray = filename.split('.');
  const ext = extArray[extArray.length - 1];

  return supportedPreviewExtensions.indexOf(ext.toLowerCase()) > -1;
}

const styles = theme => ({
  root: {
    display: 'flex',
    height: '80vh',
  },
  disableLinkStyle: {
    fontSize: '1em',
    color: 'white',
    '&:hover': {
      textDecoration: 'none',
      color: 'inherit',
    },
    underline: {
      '&:before': {
        borderBottom: 'none',
        color: 'inherit',
      },
      '&:after': {
        borderBottom: 'none',
        color: 'inherit',
      },
    },
  },
  file: {
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.common.white,
    flexGrow: 1,
  },
  download: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.dark,
  },
  downloadButton: {
    marginTop: theme.spacing(2),
  },
});

const FileViewer = ({
  fileId, householdResource, classes, className,
}) => {
  const { getFilestoreResource } = useSwaggerlessContext();
  const [href, setHref] = useState('');
  const [fileName, setFileName] = useState('');
  const [householdId] = useState(householdResource.id());

  useEffect(() => {
    getFilestoreResource(householdId, fileId)
      .then((resp) => {
        setHref(resp.data[0].links.related.href);
        setFileName(resp.data[0].attributes.name);
      })
      .catch((e) => {
        setFileName('');
        setHref('');
        displayErrorMessage(e, 'Failed to fetch file');
      });
  }, [fileId]);

  const Preview = () => (isPreviewable(fileName) ? (
    <iframe
      key="facet-file-viewer-iframe"
      width="100%"
      style={{ backgroundColor: 'white' }}
      title="File Viewer"
      src={href}
    />
  ) : (
    <Box className={classes.download}>
      <Typography component="div" variant="h6">
        {'File Preview is not supported for this file type. Please download'}
      </Typography>
      <Link
        href={href}
        className={classes.disableLinkStyle}
        title={`Download ${fileName}`}
        rel="noopener noreferrer"
        download={fileName}
      >
        <Button
          className={classes.downloadButton}
          color="primary"
          variant="contained"
          startIcon={<GetAppIcon />}
        >
          {`Download ${fileName}`}
        </Button>
      </Link>
    </Box>
  ));

  return (
    <div className={classNames(classes.root, className)}>
      <Box className={classes.file}>
        <Preview />
      </Box>
    </div>
  );
};

FileViewer.propTypes = {
  fileId: PropTypes.string.isRequired,
  householdResource: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

FileViewer.defaultProps = {
  className: '',
};

export default withStyles(styles)(FileViewer);
